var themeVars = require("app/theme/variables.js");

/**
 * Determines the setup of the ident to show on top of the video.
 *
 * @returns  {Object}  The logo setup.
 * @private
 */
module.exports = function() {
    var setup = {};

    if (themeVars.ident) {
        setup.logo            = themeVars.ident;
        setup.logoWidth       = themeVars.identWidth || 64;
        setup.logoHeight      = themeVars.identHeight || 64;
        setup.logoMinWidth    = themeVars.identMinWidth || 24;
        setup.logoMaxWidth    = themeVars.identMaxWidth || 64;
        setup.logoMinHeight   = themeVars.identMinHeight || 24;
        setup.logoMaxHeight   = themeVars.identMaxHeight || 64;
        setup.logoAspectRatio = setup.logoWidth / setup.logoHeight;
    }

    return setup;
};
